import { render, staticRenderFns } from "./ItemXor.vue?vue&type=template&id=164da79c&scoped=true&"
import script from "./ItemXor.vue?vue&type=script&lang=js&"
export * from "./ItemXor.vue?vue&type=script&lang=js&"
import style0 from "./ItemXor.vue?vue&type=style&index=0&id=164da79c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164da79c",
  null
  
)

export default component.exports